import { boot } from 'quasar/wrappers';
import {
        getOrders,
        getCustomerData,
        getOrderItems,
        getCachedProductInventory,
        getOrderComments,
        getOrdersActivitylog,
        getOrdersActivitylogV2,
        getOrder,
        getAutosuggestedCustomers,
        getProductInventory,
        getProductInventoryV2,
        updateInventoryAndStockLogs,
        getProductItem,
        getCRMURL,
        updatePrescriptionOfInventories,
        fetchOrderSource,
        fetchCustomerGroup,
        getStockMgmtReasons,
        getProductsByIds,
        getImportTask,
        getLogsByTaskId,
        getCsvSchemas,
        uploadCSVFile,
        getDoneOrdersCount,
        abortTask,
        sendPaymentLink,
        cancelPaymentLink,
        refundOrVoid,
        postGreeners,
        bulkOrderUpdate,
        getGreeners,
        createOrder2_0,
        updateOrder2_0,
        getOrderDetails,
        getReservedOrdersV2,
        processBankTransfers,
        getBankTransferTaskStatus,
        downloadProcessedCSV,
        createInvoiceWithEmail,
        getDeliveryDetails,
        updateDeliveryMethod,
        getCurrentVersion,
        getCardFloPayments,
        getNegativeVirtualAmountOrders,
        getNegativeVirtualAmountOrderDetails,
        submitMcosPrescriptionResponse
} from 'src/js/api.js';

export default boot(({ app }) => {
    app.config.globalProperties.$api = {
            getOrders,
            getCRMURL,
            getCustomerData,
            getOrderComments,
            getOrdersActivitylog,
            getOrdersActivitylogV2,
            getOrder,
            getOrderItems,
            getAutosuggestedCustomers,
            getProductInventory,
            getProductInventoryV2,
            updateInventoryAndStockLogs,
            getProductItem,
            updatePrescriptionOfInventories,
            fetchOrderSource,
            fetchCustomerGroup,
            getStockMgmtReasons,
            getProductsByIds,
            sendPaymentLink,
            cancelPaymentLink,
            bulkOrderUpdate,
            refundOrVoid,
            getImportTask,
            getLogsByTaskId,
            getCsvSchemas,
            uploadCSVFile,
            getDoneOrdersCount,
            abortTask,
            postGreeners,
            getGreeners,
            createOrder2_0,
            updateOrder2_0,
            getOrderDetails,
            getReservedOrdersV2,
            processBankTransfers,
            getBankTransferTaskStatus,
            downloadProcessedCSV,
            createInvoiceWithEmail,
            getDeliveryDetails,
            updateDeliveryMethod,
            getCurrentVersion,
            getCardFloPayments,
            getNegativeVirtualAmountOrders,
            getNegativeVirtualAmountOrderDetails,
            submitMcosPrescriptionResponse
    }
});
